import AccountingPage from './AccountingPage';

export type TTabname = 'overview' | 'transactions' | 'users';

export default AccountingPage;
